import { format, isSameDay, isSameWeek, isWithinInterval, subDays } from 'date-fns';
import { last } from 'lodash';
import { TimeRange } from '../../../types';

const isWithinLast7Days = (date: Date) => {
  return isWithinInterval(date, {
    start: subDays(new Date(), 7),
    end: new Date(),
  });
};

const buildDayName = (chart?: ChartElement) => {
  if (!chart || !chart.date) return '';

  if (chart.minute) {
    if (isSameDay(chart.date, new Date())) {
      return format(chart.date, 'h:mm a') + ' EST';
    }
    if (isSameWeek(chart.date, new Date())) {
      return format(chart.date, 'EEE h:mm a') + ' EST';
    }
    if (isWithinLast7Days(chart.date)) {
      return format(chart.date, 'EEE h:mm a') + ' EST';
    }
    return format(chart.date, 'EEE LLLL d, ha') + ' EST';
  }

  return isSameDay(chart.date, new Date()) ? 'Today' : format(chart.date, 'iiii');
};

export const buildDateText = (chart: ChartElement[], timeRange: TimeRange, selectedChartElement?: ChartElement) => {
  if (!selectedChartElement) {
    const textMapping = {
      [TimeRange.days1]: buildDayName(last(chart)),
      [TimeRange.weeks1]: 'Past\u00a0Week',
      [TimeRange.months1]: 'Past\u00a0Month',
      [TimeRange.months3]: 'Past\u00a03\u00a0Months',
      [TimeRange.months6]: 'Past\u00a06\u00a0Months',
      [TimeRange.ytd]: 'Year To Date',
      [TimeRange.years1]: 'Past\u00a0Year',
      [TimeRange.years5]: 'Past\u00a05\u00a0Years',
    };

    return textMapping[timeRange];
  }

  if (!selectedChartElement.date) return '';
  const textMapping = {
    [TimeRange.days1]: buildDayName(selectedChartElement),
    [TimeRange.weeks1]: buildDayName(selectedChartElement),
    [TimeRange.months1]: buildDayName(selectedChartElement),
    [TimeRange.months3]: format(selectedChartElement.date, 'EEEE LLLL d'),
    [TimeRange.months6]: format(selectedChartElement.date, 'EEEE LLLL d'),
    [TimeRange.ytd]: format(selectedChartElement.date, 'EEEE LLLL d, y'),
    [TimeRange.years1]: format(selectedChartElement.date, 'EEEE LLLL d, y'),
    [TimeRange.years5]: format(selectedChartElement.date, 'EEEE LLLL d, y'),
  };
  return textMapping[timeRange];
};

export const buildTechnicalDateText = (chart: ChartElement[], timeRange: TimeRange, scannedTechnicalElement?: any) => {
  if (!scannedTechnicalElement || !scannedTechnicalElement.date) {
    // Default text when no element is selected (same as news chart)
    const textMapping = {
      [TimeRange.days1]: buildDayName(last(chart)),
      [TimeRange.weeks1]: 'Past\u00a0Week',
      [TimeRange.months1]: 'Past\u00a0Month',
      [TimeRange.months3]: 'Past\u00a03\u00a0Months',
      [TimeRange.months6]: 'Past\u00a06\u00a0Months',
      [TimeRange.ytd]: 'Year To Date',
      [TimeRange.years1]: 'Past\u00a0Year',
      [TimeRange.years5]: 'Past\u00a05\u00a0Years',
    };
    return textMapping[timeRange];
  }

  // Create a chart element compatible structure from technical element
  const chartElementFromTechnical: ChartElement = {
    date: new Date(scannedTechnicalElement.date),
    minute: scannedTechnicalElement.minute,
    price: scannedTechnicalElement.price || 0, // Required by ChartElement interface
  };

  console.log('chartElementFromTechnical', chartElementFromTechnical);

  const textMapping = {
    [TimeRange.days1]: buildDayName(chartElementFromTechnical),
    [TimeRange.weeks1]: buildDayName(chartElementFromTechnical),
    [TimeRange.months1]: buildDayName(chartElementFromTechnical),
    [TimeRange.months3]: format(scannedTechnicalElement.date, 'LLLL d'),
    [TimeRange.months6]: format(scannedTechnicalElement.date, 'LLLL d'),
    [TimeRange.ytd]: format(scannedTechnicalElement.date, 'EEEE LLLL d, y'),
    [TimeRange.years1]: format(scannedTechnicalElement.date, 'LLLL d, y'),
    [TimeRange.years5]: format(scannedTechnicalElement.date, 'LLLL d, y'),
  };
  return textMapping[timeRange];
};
